// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permissions_roles-container {
    margin-top: 9rem;
    margin-left: auto;
    margin-right: auto;
    width: 95%;
}

.permission_block {
    width: 100%;
    min-height: 5.4rem;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    margin-top: .9rem;
    margin-bottom: .9rem;
    cursor: pointer;
}

.permission_block h6 {
    border-right: 1px solid gray;
    max-width: 18rem;
    line-height: 5.4rem;
    font-size: 2rem;
    font-weight: bold;
}

.permission-list {
    float: left;
    margin-top: -5.4rem;
    margin-left: 19.8rem;
    overflow: hidden;
} 

.permission-dialog-footer-container {
    display: flex;
    gap: 10px;
}

.permission-dialog-cancel {
    background-color: #d22e37;
}`, "",{"version":3,"sources":["webpack://./src/app/permission/permission-main/permission-tabs/permission-role-list/PermissionRoleList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+GAA+G;IAC/G,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".permissions_roles-container {\r\n    margin-top: 9rem;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 95%;\r\n}\r\n\r\n.permission_block {\r\n    width: 100%;\r\n    min-height: 5.4rem;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\r\n    margin-top: .9rem;\r\n    margin-bottom: .9rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.permission_block h6 {\r\n    border-right: 1px solid gray;\r\n    max-width: 18rem;\r\n    line-height: 5.4rem;\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.permission-list {\r\n    float: left;\r\n    margin-top: -5.4rem;\r\n    margin-left: 19.8rem;\r\n    overflow: hidden;\r\n} \r\n\r\n.permission-dialog-footer-container {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.permission-dialog-cancel {\r\n    background-color: #d22e37;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
